import { FormField } from "@sp-state/useSignupFormDrip";
import { fireMxpEvent } from "./mixpanelEvents/mixpanelEvents";
import { trialSignupCompleted } from "./segment/trialSignUpCompleted";
import { getFormattedTime } from "../assets/util-scripts/helpers";
import { iterableSubmit } from "./iterableSubmit";
import { leadCapture } from "./segment/leadCapture";

type SignUpDripStepCompleted = {
  fields: FormField[] | undefined;
  step: number;
  promoCode?: string;
};

export function signUpDripStepCompleted({
  fields,
  step,
  promoCode,
}: SignUpDripStepCompleted) {
  const fieldsNames = fields?.map(item => {
    if (item?.field === "questions") {
      const questionAttribute = item?.questionAttributes;

      return questionAttribute?.questionName;
    }

    return item.field;
  });

  fireMxpEvent("user: sign up drip step completed", {
    fields: fieldsNames,
    step: `step ${step} completed`,
  });
  trialSignupCompleted(fieldsNames, step, promoCode);
}

type FireLeadAndIterableEvents = {
  fields: FormField[];
  email: {
    value: string;
    isValid: boolean;
  };
};

export function fireLeadAndIterableEventsForEmailField({
  fields,
  email: { value, isValid },
}: FireLeadAndIterableEvents) {
  if (
    !fields.some(f => f.field === "email") ||
    value.trim() === "" ||
    !isValid
  ) {
    return;
  }

  const analyticsData = {
    text: "Continue",
    email: value,
  };
  const submitEmailData = {
    email: value,
    SIGN_UP_SOURCE: "Website - Sign Up Form",
    startTrialFlowAt: getFormattedTime(),
  };

  leadCapture(analyticsData);
  iterableSubmit(submitEmailData);
}
